import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUsersDownload = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  
  return useMutation({
    mutationFn: async ({ name, courseGroups, userGroup, onlineDeltaTime }) => {
      const result = await restClient({ 
        url: `${prefix}/users/download`, 
        method: 'post',
        data: {
          name,
          courseGroups,
          userGroup,
          onlineDeltaTime,
          showCompletedChallenges: true
        },
        responseType: 'blob'
      });
      return result.data;
    },
    onSuccess: async () => {
    }
  });
};
